import { VariavelService } from './../../shared/service/variavel.service';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FFlowModule } from '@foblex/flow';
import { FormRequisicaoComponent } from '../cadastro-requisicao/form-requisicao.component';
import { FlowConnection, FlowNode } from '../chatbot-flow-component';
import { TipoEtapa } from '../../shared/enum/tipo-etapa-enum';
import { FluxoService } from '../../shared/service/fluxo-service';
import { FluxoSelect } from '../../shared/model/fluxo/fluxo-select-model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { SelectOneComponent } from '../../shared/components/select-one/select-one.component';
import { CanalService } from '../../shared/service/canal.service';
import { IdNome } from '../../shared/model/id-nome.model';
import { MsgService } from '../../shared/service/msg.service';
import { ValidacaoAlteracaoCampoService } from '../../shared/service/utilitarios/validacao-alteracao-campo.service';
import { FormCapturaComponent } from '../cadastro-captura/form-captura.component';
import { VariavelSelect } from '../../shared/model/variavel/variavel-select.model';
import { MetodoValidadorVariavel } from '../../shared/enum/metodo-validador-variavel-enum';
import { TipoEtapaCaptacaoEnum } from '../../shared/enum/tipo-etapa-captura-enum';
import { TipoFluxoEnum } from '../../shared/enum/tipo-fluxo.enum';
import { SelectMultipleComponent } from '../../shared/components/select-multiple/select-multiple.component';
import { EtapaVariavelEnvio } from '../../shared/model/etapa/etapa-variavel-envio-model';
import { TipoAcao } from '../../shared/enum/tipo-acao-enum';
import { MetodoRequisicaoEnum } from '../../shared/enum/metodo-requisicao-enum';

@Component({
  selector: 'app-chatbot-sidenav',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FFlowModule,
    FormRequisicaoComponent,
    FormFieldComponent,
    ButtonPadraoComponent,
    SelectOneComponent,
    FormCapturaComponent,
    SelectMultipleComponent
  ],
  templateUrl: './chatbot-flow-sidenav-component.html',
  styleUrls: ['./chatbot-flow-sidenav-component.css'],
})
export class ChatbotSideNavComponent implements OnInit {
  tipoFluxo?: any;
  selectedNodeEditando: FlowNode | null = null;
  conexoesNodeEditando: FlowConnection[] = [];
  tipoEtapas: any;
  acoes: any;
  metodosValidadores: any;
  tipoEtapa = TipoEtapa;
  fluxoErroSelect: FluxoSelect[] = [];
  fluxoPesquisaSelect: FluxoSelect[] = [];
  fluxosSelect: FluxoSelect[] = [];
  variaveisSelect: VariavelSelect[] = [];
  variaveisDoFluxoSelect: VariavelSelect[] = [];
  canais: IdNome[] = [];
  isCanal = false;
  isUltimo = false;
  disabledTipoEtapa = false;
  isRequisicao = false;
  isRequisicaoRetorno = false;
  isOpcaoLista = false;
  isCaptura = false;
  isAcao = false;
  isDifyAgentAi = false;
  camposSelect: any[] = [];
  metodos: string[] = [];
  conversationIdSelecionado: any;
  isEntrada = false;
  isTextoComVariavel = false;
  variavelSelecionada: VariavelSelect | null = null;
  fluxoId: number | null = null;
  variaveisEnvioSelecionadas: VariavelSelect[] = [];
  metodosComCorpo: string[] = ['POST', 'PUT', 'PATCH'];
  metodosAgente: { label: string, value: number }[] = [];
  metodoAgenteSelecionado: { label: string, value: number } | null = null;

  data = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ChatbotSideNavComponent>);
  private readonly fluxoService = inject(FluxoService);
  private readonly canalService = inject(CanalService);
  private readonly msgService = inject(MsgService);
  private readonly variavelService = inject(VariavelService);
  readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit(): void {
    this.alteracaoService.camposNaoAlterados();
    this.selectedNodeEditando = this.data['node'];
    this.conexoesNodeEditando = this.data['conections'];
    this.fluxoId = this.data['fluxoId'];
    this.isUltimo = this.data['isUltimo'];
    this.tipoFluxo = this.data['tipo'];
    this.metodos = Object.values(MetodoRequisicaoEnum);
    if (TipoFluxoEnum[this.tipoFluxo] == TipoFluxoEnum.PADRAO.toString()) {
      this.buscarFluxosPesquisa();
    }
    this.tipoEtapas = Object.entries(TipoEtapa).map(([key, value]) => ({
      value: key,
      label: value,
      disabled: key === 'OPCAO_LISTA',
    }));
    this.metodosValidadores = Object.entries(MetodoValidadorVariavel).map(
      ([key, value]) => ({
        value: key,
        label: value,
      })
    );
    this.metodosAgente = Object.values(MetodoRequisicaoEnum).map((label, index) => ({
      label,
      value: index
    }));
    const metodoSalvo = this.selectedNodeEditando?.agentAiDify?.metodo;
    if (metodoSalvo != null && metodoSalvo !== 'undefined') {
      const metodoAgenteIa = this.metodosAgente.find(m => m.value === Number (metodoSalvo));
      this.metodoAgenteSelecionado = metodoAgenteIa ? metodoAgenteIa : null;
    }
    this.acoes = Object.entries(TipoAcao).map(
      ([key, value]) => ({
        value: key,
        label: value,
        disabled: key === 'ENCERRAR_SESSAO' && !this.isUltimo ,
      })
    );
    this.buscarFluxosErroSelect();
    this.buscarFluxosSelect();
    this.buscarVariaveisSelect();
    this.buscarVariaveisDoFluxo();
    if (this.selectedNodeEditando && this.selectedNodeEditando.tipoEtapa) {
      this.selecionarTipo(
        this.tipoEtapas.find(
          (t: any) =>
            t.value == this.selectedNodeEditando!.tipoEtapa ||
            t.label == this.selectedNodeEditando!.tipoEtapa
        )
      );
    }
    if (
      this.selectedNodeEditando &&
      this.selectedNodeEditando.metodoValidador
    ) {
      this.selecionarMetodoValidador(
        this.metodosValidadores.find(
          (t: any) =>
            t.value == this.selectedNodeEditando!.metodoValidador ||
            t.label == this.selectedNodeEditando!.metodoValidador
        )
      );
    }

    if (
      this.selectedNodeEditando &&
      this.selectedNodeEditando.acaoEtapa
    ) {
      this.selecionarAcao(
        this.acoes.find(
          (t: any) =>
            t.value == this.selectedNodeEditando!.acaoEtapa ||
            t.label == this.selectedNodeEditando!.acaoEtapa
        )
      );
    }
    this.atualizarVariaveisSelecionadas();
  }

  salvarEdicao() {
    if (this.validado()) {
      this.dialogRef.close(this.selectedNodeEditando);
    } else {
      this.msgService.msgAdvertencia('Preencha todos os campos obrigatórios!');
    }
  }

  cancelEdit() {
    this.dialogRef.close();
  }

  validado(): boolean {
    if (
      !this.selectedNodeEditando ||
      !this.selectedNodeEditando.title ||
      this.selectedNodeEditando.title.length === 0 ||
      !this.selectedNodeEditando.tipoEtapa
    ) {
      return false;
    }

    if (this.selectedNodeEditando.possuiTransbordo
      && (this.selectedNodeEditando.fluxoTransbordo == null || this.selectedNodeEditando.timerTransbordo == null)
    ) {
      return false;
    }

    if (this.isOpcaoLista) {
      return !!(
        this.selectedNodeEditando.tituloOpcao &&
        this.selectedNodeEditando.tituloOpcao.length > 0 &&
        this.selectedNodeEditando.descricaoOpcao &&
        this.selectedNodeEditando.descricaoOpcao.length > 0
      );
    }

    if (this.isEntrada) {
      return !!(
        this.selectedNodeEditando.metodoValidador &&
        this.selectedNodeEditando.variavelRespostaId &&
        this.selectedNodeEditando.variavelRespostaId.toString().length > 0
      );
    }

    if (this.isCaptura) {
      if (
        !this.selectedNodeEditando.capturas ||
        this.selectedNodeEditando.capturas.length === 0
      ) {
        return false;
      }

      return this.selectedNodeEditando.capturas.every((c) => {
        if (!c.tipoCaptura || !c.valorCaptura) {
          return false;
        }

        if (c.tipoCaptura === TipoEtapaCaptacaoEnum.PREENCHIMENTO) {
          return !!c.valorInsercao && !!c.variavelSalvamentoId;
        }

        if (c.tipoCaptura === TipoEtapaCaptacaoEnum.REDIRECIONAMENTO) {
          return !!c.fluxoEnvioId;
        }

        return true;
      });
    }

    if(this.isAcao){
      return !!this.selectedNodeEditando.acaoEtapa;
    }

    if (this.isRequisicao || this.isRequisicaoRetorno) {
      const req = this.selectedNodeEditando.requisicao;

      if (!req || !req.url) {
        return false;
      }

      if (this.metodosComCorpo.includes(req.metodo || '') && !req.contentType) {
        return false;
      }

      const cabecalhosValidos = req.cabecalhos?.every(c => c.chave && c.valor) ?? true;
      if (!cabecalhosValidos) {
        return false;
      }

      const parametrosValidos = req.parametros?.every(p => p.nome && p.tipo && p.valor != null) ?? true;
      if (!parametrosValidos) {
        return false;
      }

      if(this.isRequisicaoRetorno){
        if(!this.selectedNodeEditando.requisicao?.tipoRetorno){
          return false;
        }
      }

      return true;
    }

    if (this.isCanal) {
      if (this.selectedNodeEditando?.canal == null) {
        return false;
      }

      return true;
    }

    return true;
  }

  selecionarTipo(event: any) {
    if (!event || !this.selectedNodeEditando) {
      return;
    }

    this.selectedNodeEditando.tipoEtapa = event;

    this.disabledTipoEtapa = false;
    this.isOpcaoLista = false;
    this.isRequisicao = false;
    this.isCanal = false;
    this.isCaptura = false;
    this.isEntrada = false;
    this.isTextoComVariavel = false;
    this.isRequisicaoRetorno = false;
    this.isAcao = false;
    this.isDifyAgentAi = false;

    switch (event.label) {
      case TipoEtapa.OPCAO_LISTA:
        this.disabledTipoEtapa = true;
        this.isOpcaoLista = true;
        break;

      case TipoEtapa.LISTA:
        this.disabledTipoEtapa = !this.isUltimo;
        break;

      case TipoEtapa.REQUISICAO:
        this.isRequisicao = true;
        break;

      case TipoEtapa.CANAL:
        this.isCanal = true;
        this.buscarCanais();
        break;

      case TipoEtapa.CAPTURA:
        this.isCaptura = true;
        break;

      case TipoEtapa.ENTRADA:
        this.isEntrada = true;
        this.buscarVariaveisSelect();
        break;

      case TipoEtapa.TEXTO_VARIAVEIS:
        this.isTextoComVariavel = true;
        break;

      case TipoEtapa.REQUISICAO_RETORNO:
        this.isRequisicaoRetorno = true;
        break;

      case TipoEtapa.ACAO:
        this.isAcao = true;
        break;

      case TipoEtapa.AGENTE_IA_DIFY:
        this.isDifyAgentAi = true;
        this.buscarVariaveisSelect();
        break;
    }
  }

  selecionarAcao(event: any) {
    if (event && this.selectedNodeEditando) {
      this.selectedNodeEditando.acaoEtapa = event.value;
    }
  }

  selecionarConversationId(event: any) {
    if (event && this.selectedNodeEditando?.agentAiDify) {
      this.selectedNodeEditando.agentAiDify.variavelId = event.id;
      this.conversationIdSelecionado = event;
      this.alteracaoService.camposAlterado();
    }
  }

  selecionarMetodoAgente(event: any) {
    if (event && this.selectedNodeEditando?.agentAiDify) {
      this.selectedNodeEditando.agentAiDify.metodo = event.value;
      this.metodoAgenteSelecionado = event;
      this.alteracaoService.camposAlterado();
    }
  }

  selecionarMetodoValidador(event: any) {
    if (!event || !this.selectedNodeEditando) {
      return;
    }

    const valor = event.value ?? event;

    this.selectedNodeEditando.metodoValidador = valor;
  }

  buscarFluxosErroSelect() {
    this.fluxoService.buscarFluxoErroSelect().subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.fluxoErroSelect = res;
        }
      },
    });
  }

  buscarFluxosPesquisa() {
    this.fluxoService.buscarSelectPeloTipo([TipoFluxoEnum.PESQUISA]).subscribe({
      next: (res) => this.fluxoPesquisaSelect = res
    });
  }

  buscarCanais() {
    this.canalService.buscarCanaisAtivoDoGrupo().subscribe({
      next: (res) => (this.canais = res),
    });
  }

  buscarFluxosSelect() {
    this.fluxoService.buscarFluxoSelect().subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.fluxosSelect = res;
        }
      },
    });
  }

  buscarVariaveisSelect() {
    const isPesquisa = TipoFluxoEnum[this.tipoFluxo] == TipoFluxoEnum.PESQUISA.toString();
    if (isPesquisa || this.isEntrada) {
      this.variavelService.buscarVariavelSelectComFiltroPesquisa(isPesquisa).subscribe({
        next: (res) => {
          if (res.length > 0) {
            this.variaveisSelect = res;
          }
        },
      });
    }else if(this.isDifyAgentAi){
      this.variavelService.buscarVariavelSelect().subscribe({
        next: (res) => {
          if (res.length > 0) {
            this.camposSelect = res;
            const idSalvo = this.selectedNodeEditando?.agentAiDify?.variavelId;
            if(idSalvo){
              this.conversationIdSelecionado = this.camposSelect.find((v: VariavelSelect) => v.id === idSalvo);
            }
          }
        },
      });
    }
  }

  buscarVariaveisDoFluxo() {
    if (this.fluxoId) {
      this.variavelService.buscarVariavelSelectComFiltroPesquisa(false).subscribe({
        next: (res) => {
          if (res.length > 0) {
            this.variaveisDoFluxoSelect = res;
          }
        },
        complete: () => this.atualizarVariaveisSelecionadas()
      });
    }
  }

  getVariavelSelecionada(flowNode: FlowNode): VariavelSelect | null {
    return (
      this.variaveisSelect.find((v) => v.id === flowNode.variavelRespostaId) ||
      null
    );
  }

  selecionarVariavel(event: any, flowNode: FlowNode) {
    if (event) {
      flowNode.variavelRespostaId = event.id;
      this.variavelSelecionada = event;
    }
  }

  selecionarVariaveisEnvio(event: VariavelSelect[]) {
    if (!this.selectedNodeEditando) return;

    this.selectedNodeEditando.variaveisEnvio = event.map((variavel) => {
      const variavelEnvio = new EtapaVariavelEnvio();
      variavelEnvio.etapaId = this.selectedNodeEditando?.etapaId;
      variavelEnvio.variavel = variavel;
      return variavelEnvio;
    });

    this.atualizarTextoComVariaveis();

    this.atualizarVariaveisSelecionadas();
  }

  atualizarTextoComVariaveis() {
    if (!this.selectedNodeEditando) return;

    let textoAtual = this.selectedNodeEditando.content || '';
    const variaveisSelecionadas = this.selectedNodeEditando.variaveisEnvio?.map(v => `@${v.variavel?.nome}`) || [];

    textoAtual = textoAtual.replace(/@\w+/g, '');

    this.selectedNodeEditando.content = textoAtual.trim() + (variaveisSelecionadas.length ? ' ' + variaveisSelecionadas.join(' ') : '');
  }

  textoAlterado() {
    if (!this.selectedNodeEditando) return;

    const texto = this.selectedNodeEditando.content || '';

    this.selectedNodeEditando.variaveisEnvio = this.selectedNodeEditando.variaveisEnvio?.filter(v =>
      texto.includes(`@${v.variavel?.nome}`)
    );

    this.atualizarVariaveisSelecionadas();
  }

  atualizarVariaveisSelecionadas() {
    if (this.variaveisDoFluxoSelect.length > 0) {
      if (!this.selectedNodeEditando?.variaveisEnvio) {
        this.variaveisEnvioSelecionadas = [];
      } else {
        const ids = this.selectedNodeEditando.variaveisEnvio.map(v => v.variavel?.id);
        this.variaveisEnvioSelecionadas = this.variaveisDoFluxoSelect.filter(v => ids.includes(v.id));
      }
    }
  }
}
